/* eslint-disable prettier/prettier */
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

export function initPageListSplide() {
    const elms = document.getElementsByClassName('splide') as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < elms.length; i++) {
        const el = elms[i];
        const slides = el.getElementsByClassName('splide__slide');
        const slideCount = slides.length;

        if (slideCount <= 0) continue;

        const activeAtDesktop = slideCount > 3;
        const activeAtTablet = slideCount > 2;
        const activeAtMobile = slideCount > 1;
        const typeAtDesktop = slideCount > 3 ? 'loop' : 'slide';
        const typeAtTablet = slideCount > 2 ? 'loop' : 'slide';
        const typeAtMobile = slideCount > 1 ? 'loop' : 'slide';

        const splide = new Splide(el, {
            type: typeAtDesktop,
            perPage: 3,
            gap: 20,
            focus: 0,
            drag: activeAtDesktop,
            arrows: activeAtDesktop,
            pagination: activeAtDesktop,
            breakpoints: {
                1024: {
                    type: typeAtTablet,
                    perPage: 2,
                    drag: activeAtTablet,
                    arrows: activeAtTablet,
                    pagination: activeAtTablet,
                },
                719: {
                    type: typeAtMobile,
                    perPage: 1,
                    drag: activeAtMobile,
                    arrows: activeAtMobile,
                    pagination: activeAtMobile,
                    padding: { left: '1rem', right: '1rem' },
                },
            },
        });

        splide.mount();
    }
}